<template>
  <div class="header">
    <div class="layer">
      <img src="../assets/logo.png" class="logo" />
      <ul class="nav">
        <li :class="tab_index == 0 ? 'select' : ''" @click="naviToIndex">
          <a>首页</a>
        </li>
        <li :class="tab_index == 1 ? 'select' : ''" @click="naviToSchedule">
          <a>大赛赛程</a>
        </li>
        <li :class="tab_index == 2 ? 'select' : ''" @click="naviToLast">
          <a>首届回顾</a>
        </li>
        <!-- <li :class="tab_index == 3 ? 'select' : ''" @click="naviToRank">入围榜单</li> -->
        <li :class="tab_index == 4 ? 'select' : ''" @click="naviToData">
          <a>产品资料</a>
        </li>
        <li v-if="had_login" @click="naviToCenter">
          <img src="../assets/login-icon.png" class="login-in" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import "vant/lib/toast/style";

import api from "../api/api";
export default {
  name: "",
  props: {
    tab_index: 0,
    had_login: false,
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    naviToLast() {
      this.$router.push("/last");
    },
    naviToIndex() {
      this.$router.push("/");
    },
    naviToSchedule() {
      this.$router.push("/schedule");
    },
    naviToRank() {
      this.$router.push("/rank");
    },
    naviToData() {
      if (this.had_login == false) {
        Toast("请先登录");
      } else {
        this.$router.push("/data");
      }
    },
    naviToCenter() {
      this.$router.push("/center");
    },
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Topbar.vue